<script>
  import OrderForm from "./OrderForm.svelte";

  export let id = "";
  export let brk = 0;
  export let lun = 0;
  export let days = 0;
  export let carb = "";
  export let totalMeals = 0;
</script>

<hr />
<h2>Please select you meals for order #{id}</h2>
<p>Total number of meals = {totalMeals}</p>
<p>Total number of days = {days}</p>
<p>Total number of breakfast/day = {brk}</p>
<p>Total number of lunch/dinner/day = {lun}</p>
{#if carb !== ''}
  <p>No Carb Order</p>
{/if}

<OrderForm {id} {brk} {lun} {days} {carb} availableMeals={totalMeals} />
